export const RegExPatterns = {
	onlyNumbers: /[^0-9+]/g,
	onlyNumbersAndLetters: /[^a-zA-Z0-9]/g,
};
